import React from "react";
import FreelancerPayableAssignment from "../Domain/FreelancerPayableAssignmentsItem";
import FreelancerPayableAssignmentsService from "../Services/FreelancerPayableAssignmentsService";
import TabOfDataTable from "./DataTable/TabOfDataTable";

export default class ShowPayableAssignmentComponent extends React.Component {
  static defaultProps = {
    freelancerInvoiceId: null,
  };

  render() {
    if (!this.props.freelancerInvoiceId) return <div>There is no data here.</div>;
    return (
      <TabOfDataTable
        type={FreelancerPayableAssignment}
        serviceFunction={() => FreelancerPayableAssignmentsService.GetAssignmentListByInvoiceId(this.props.freelancerInvoiceId)}
        convertDBItemsFunction={FreelancerPayableAssignmentsService.ConvertDBItem}
        numberOfElementsOnAPage={99999}
        errorCode="SPAC21"
      />
    );
  }
}
